import { Component, DestroyRef, inject, input, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, first } from 'rxjs';
import { MakeAPaymentService } from '../../custom-make-a-payment/make-a-payment.service';
import { OpenStatementsService } from '../open-statements.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AllStatements } from '../model/statment.model';
import { CommonUtils } from '../../shared/utils/common.utils';
import { EU_DATE_FORMAT, US_DATE_FORMAT } from '../../shared/config/app.config';
import { SalesOrg } from '../../shared/config/app.config';

@Component({
  selector: 'app-statement-display',
  templateUrl: './statement-display.component.html',
  styleUrls: ['./statement-display.component.scss'],
  host: {
    '[style.width]': '"100%"',
  },
  standalone: false
})
export class StatementDisplayComponent implements OnInit {
  accountNumber = input.required<string>();
  isCustomerEmulated = input.required<boolean>();
  salesOrg = input.required<SalesOrg>();
  @Input() toShow: boolean;
  @Input() statement: any;
  allStatementData: AllStatements;

  private stService = inject(OpenStatementsService);
  private makeAPayment = inject(MakeAPaymentService);
  public activeModal = inject(NgbActiveModal);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly EU_DATE_FORMAT = EU_DATE_FORMAT;
  protected readonly US_DATE_FORMAT = US_DATE_FORMAT;
  protected readonly CommonUtils = CommonUtils;
  protected readonly SalesOrg = SalesOrg;

  ngOnInit(): void {
    this.stService.loadStatements
      .pipe(
        filter(Boolean),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.getAllStatements();
      });
  }

  checkNegativeValue(data, checkNegative = false) {
    return checkNegative ? Number(data) < 0 : data?.transType === 'Credit Memo';
  }

  generateInvoicePDF(invoiceNo) {
    this.makeAPayment.downloadPdf(invoiceNo);
  }

  getAllStatements() {
    const params = {
      accountId: this.accountNumber(),
      endDate: this.statement.toDte,
      fields: 'DEFAULT',
    };


    this.stService
      .getAllStatements(this.isCustomerEmulated() ? { emulatedUser: localStorage.getItem('asmUserId'), ...params } : params)
      .pipe(
        first(Boolean),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (res) => {
          this.allStatementData = JSON.parse(JSON.stringify(res));
          this.allStatementData.statementTableData.sort((a, b) => CommonUtils.sortDateWithMoment(a.documentDate, b.documentDate));
        },
        error: (error) => {
          console.info(error);
          this.allStatementData = {} as AllStatements;
        }
      });
  }
}
